// extracted by mini-css-extract-plugin
export default {"root":"JMSfX","row":"-WUeV","text":"_32sb4","date":"_3igwg","total":"_3w9mk","arrow":"_3T8p-"};